import axios from '../_helpers/axios';

export const adjust_geofence_summary_kmService = {
    adjust_geofence_summary_km,
    get_geofence_summary_km,
};

async function adjust_geofence_summary_km(data) {
  return new Promise((resolve, reject) => {
    axios.post('adjust_geofence_summary_km', data)
    .then(resp => {
        resolve(resp)
    }).catch(function(error){
      if (error.response && error.response.data && error.response.data.error) {
        reject(error.response.data.error)
        return
      }
      reject(error)
    })
  })
}

async function get_geofence_summary_km(data) {
  return new Promise((resolve, reject) => {
    axios.post('get_geofence_summary_km', data)
    .then(resp => {
        if(resp.data && resp.data.data){
          resolve(resp.data.data)
        }
    }).catch(function(error){
      if (error.response && error.response.data && error.response.data.error) {
        reject(error.response.data.error.error_message)
        return
      }
      reject(error)
    })
  })
}
